import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { PATHS } from "../../constant";

export default function passwordChangeModal() {
  return (
    <div className="password-modal">
      <div className="password-change">Password changed successfully!</div>
      <Link
        to={{
          pathname: PATHS.DASHBOARD
        }}
      >
        <Button variant="primary" type="button" className="btn-orange">
          Go To Dashboard
        </Button>
      </Link>
    </div>
  );
}
